import React from 'react';
import './AdminStyles.scss';

const AdminTableSkeleton = ({ columns = 5, rows = 5 }) => {
    return (
        <div className="admin-table-container">
            <table className="admin-table">
                <thead>
                    <tr>
                        {Array.from({ length: columns }).map((_, idx) => (
                            <th key={idx}>
                                <div className="skeleton skeleton-text" style={{ width: '80%' }}></div>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: rows }).map((_, rowIndex) => (
                        <tr key={rowIndex}>
                            {Array.from({ length: columns }).map((_, colIndex) => (
                                <td key={colIndex}>
                                    <div className="skeleton skeleton-text" style={{ width: colIndex === 0 ? '60%' : '100%' }}></div>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AdminTableSkeleton;
